export class WorkFlowRefectSignRequest {
  token?: string;
  workFlowId?: number;
  rejectReason?: string;
  togetherWorkFlowIds?: Array<number>;
  rejectFlowId?: number;
  rejectFlowUserId?: number;
}
